// import Record from  'common/js/UBaseRecord'
/**
 * 从手机获得照片
 * @param album true 代表相册获取 false 从相机获取 默认false
 * @param success 选取照片成功后回调，参数 照片地址
 * @param failure 选取照片失败后回调， 参数 错误原因
 */
import {
  commonParams
} from 'common/config/config'
import {
  formatLimit
} from 'common/utils/fileUtils'
import UGlobalService from 'common/js/UGlobalService'
import * as Convert from 'homework/components/universal/uploader/convertExit.js'
import i18n from '../../i18n'
import { getPlatform } from 'common/utils/platform'
export function getUser (success) {
  if (window.ULplugin && window.ULplugin.User) {
    window.ULplugin.User.getUser(function (user) {
      console.log(user)
      success && success(user)
    })
  }
}
/*
 * 异地登录下线
 * */
export function loggedOnOtherDevices (token, success, fail) {
  if (window.ULplugin && window.ULplugin.User) {
    window.ULplugin.User.loggedOnOtherDevices(token, function () {
      success && success()
    }, function () {
      fail && fail()
    })
  }
}

export function getPictureFromMobile (album = false, success, failure, limitNum = 3, videoType = true) {
  let options = {}
  options.macAccount = limitNum
  if (album) {
    options.sourceType = 1
  } else {
    options.sourceType = 0
    if (videoType) {
      options.mediaType = 2
    }
  }
  window.ULplugin.Camera.getPicture(function (result) {
    let arr = []
    if (result && result.length > 0) {
      let fileArr = result.split(',')
      fileArr.forEach((file) => {
        if (!/^file/.test(file)) {
          file = 'file://' + file
        }
        let fileName = file.split('/').pop().toString()
        arr.push({
          path: file,
          name: fileName
        })
      })
    }
    success && success(arr)
  }, function (err) {
    console.log(err)
    if (err.toLowerCase() === 'no image selected') {
      if (!getPlatform().isIOS) {
        failure && failure(i18n.t('m.mobilePermissionTip1'))
      }
    } else {
      failure && failure(err)
    }
  }, options)
}

export function selectFileFromiOS (success, maxCount) {
  window.ULplugin.Camera.selectFileFromiOS(function (result) {
    let arr = []
    if (result && result.length > 0) {
      let fileArr = JSON.parse(result)
      fileArr.forEach((file) => {
        if (!/^file/.test(file.filepath)) {
          file.filepath = 'file://' + file.filepath
        }
        arr.push({
          path: file.filepath,
          name: file.filename
        })
      })
    }
    success && success(arr)
  }, function (err) {
    alert(err)
  })
}

export function selectFileFromAndroid (success, maxCount) {
  // var fileType = '*.doc;*.mp3;*.mp4;*.rar;'
  var wordType = '*.doc;*.docx;*.xls;*.xlsx;*.pptx;*.ppt;*.pdf;*.txt;'
  var videoType = '*.mp4;*.avi;*.mov;*.flv;*.rmvb;*.mpg;'
  var audioType = '*.mp3;*.mov;'
  var picType = '.jpg;*.jpeg;*.png;*.gif;'
  var fileType = wordType + videoType + audioType + picType
  var fileSize = 200
  window.ULplugin.UFile.selectFile(fileType, 5000, maxCount || 1, fileSize)
  window.ULplugin.UFile.onSelectedFiles = function (fileCount, fileSize, fileArr) {
    console.log(fileCount, fileSize, fileArr)
    let arr = []
    if (fileArr && fileArr.length > 0) {
      let fileList = JSON.parse(fileArr)
      fileList.forEach((fileModel) => {
        if (fileModel.filepath && !/^file/.test(fileModel.filepath)) {
          let Obj = {}
          Obj.filePath = 'file://' + fileModel.filepath
          Obj.fileType = formatLimit(fileModel.filepath)
          Obj.fileSize = fileModel.length
          Obj.fileName = fileModel.filename
          arr.push(Obj)
        }
      })
    }
    success && success(arr)
  }
}

import Recorder from "recorder-core";
//需要使用到的音频格式编码引擎的js文件统统加载进来，这些引擎文件会比较大
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";


// 等待状态
const ULRECORDREADY = 0

// 检查权限中
const ULRECORDCHECK = 1
// 录音中
const ULRECORDING = 2
// 录音结束
const ULRECORDEND = 3
// 检查权限拒绝
const ULRECORDDENY = 4

class Record {
  constructor () {
    // 录音的状态
    this.status = ULRECORDREADY
    // 文件路径
    this.filePath = ''
    
    this.fileBlob = ''
    // 当前声音时长
    this.currentDuration = 0
    // 录音最大时长
    this.durationLimit = 180
    // 定时器
    this._timer = {}

    this.onBeforeStartRecord = function () {}
    this.startRecord = function (success, failure, durationChange) {
      if (this.filePath) {
        this.filePath = ''
        this.status = ULRECORDREADY
      }
      // if (this.status !== ULRECORDREADY) {
      //   // 正在录音中，稍后重试
      //   failure && failure('正在录音请稍后重试')
      //   return
      // }
      // 状态切换为检查中
      this.status = ULRECORDCHECK
      this.onDurationChange = durationChange
      let _this = this

      if (getPlatform().isInApp) {
        window.ULplugin.URecorder.onStartRecord = function () {
          _this.onBeforeStartRecord && _this.onBeforeStartRecord()
          _this.status = ULRECORDING
          _this.currentDuration = 0
          _this._timer = setInterval(function () {
            if (_this.currentDuration >= _this.durationLimit) {
              window.ULplugin.URecorder.stopRecord()
              return
            }
  
            //  不录音时，或者时间超过限制，停止计时，停止录音
            if (_this.status === ULRECORDREADY || _this.status === ULRECORDEND || _this.currentDuration >= _this.durationLimit) {
              _this.stopRecord()
              clearInterval(_this._timer)
              return
            }
            _this.currentDuration++
            _this.onDurationChange && _this.onDurationChange(_this.currentDuration)
          }, 1000)
        }
        window.ULplugin.URecorder.onRecordComplete = function (filePath) {
          _this.status = ULRECORDEND
          _this.filePath = filePath
          if (this._timer) {
            clearInterval(this._timer)
          }
          _this.onRecordCompleteSuccess && _this.onRecordCompleteSuccess(filePath, _this.currentDuration)
          _this.currentDuration = 0
        }
        window.ULplugin.URecorder.checkPermission(() => {
          //  权限允许
          success && success()
          window.ULplugin.URecorder.startRecord()
        }, (msg) => {
          _this.status = ULRECORDDENY
          failure && failure(i18n.t('请打开手机权限'))
          //  权限拒绝
        })
      } else {
        this.recorder = Recorder({
          type: "mp3",
          bitRate: 16,
          sampleRate: 16000,
          onProcess: (buffers, powerLevel, duration, sampleRate) => {
            // if (this.isDrawerVisible == false) {
            //   return;
            // }
            _this.recorderDuration = Math.floor(duration / 1000);
            if (_this.status === ULRECORDREADY || _this.status === ULRECORDEND || _this.currentDuration >= _this.durationLimit) {
              this.stopRecorder();
            }
            _this.onDurationChange && _this.onDurationChange(_this.recorderDuration)
            _this.currentDuration = _this.recorderDuration
          },
        });
        this.recorder.open(
          () => {
            console.log("已打开mac");
            this.recorder.start();
          },
          (msg, isUserNotAllow) => {
            // console.log(msg, isUserNotAllow);
            // this.recorderDuration = 0;
            // if (isUserNotAllow) {
            //   this.$msgbox.toast(this.$t('uploadTip5'), {
            //     type: "warning",
            //   });
            // }
          }
        );
        _this.onBeforeStartRecord && _this.onBeforeStartRecord()
        _this.status = ULRECORDING
        _this.currentDuration = 0
      }
      
    }

    this.stopRecord = function () {
      // this.status = ULRECORDREADY
      if (getPlatform().isInApp) {
        window.ULplugin.URecorder.stopRecord()
      } else {
        this.recorder && this.recorder.stop(
          (blob, duration) => {
            console.log(blob, duration);
            this.status = ULRECORDEND
            let path = URL.createObjectURL(blob)
            console.log(path)
            this.filePath = path
            this.fileBlob = blob
            this.onRecordCompleteSuccess && this.onRecordCompleteSuccess(path, Math.floor(duration / 1000), blob)
            this.currentDuration = 0
          },
          (error) => {
            console.error(error);
            this.currentDuration = 0;
          },
          true
        )
      }
      
    }


    this.clearRecord = function () {
      this.status = ULRECORDREADY
      this.filePath = ''
      this.currentDuration = 0
      this.stopRecord()
    }
    // 录音完成的回调
    this.onRecordCompleteSuccess = function () {}

    this.onDurationChange = function () {}
  }
}

class Media {
  constructor () {
    // 图片查看
    this.imgPreview = function (imgpath) {
      window.ULplugin.UFile.imgPreview(imgpath)
    }
    // 打开文档
    this.openFileInOtherApp = function (path) {
      window.ULplugin.UFile.openFileInOtherApp(path)
    }
    // 打开视频
    this.openVideo = function (path) {
      window.ULplugin.UMedia.playVideo(path)
    }
  }
}

export function creatMedia () {
  return new Media()
}

/***
 *录音对象
 */
export function creatRecord () {
  return new Record()
}

/*
 * 退出App
 * */
export function exitApp () {
  if (getPlatform().isInApp) {
    if (window.ULplugin) {
      window.ULplugin.UApp.finish()
    }
  } else {
    window.history.back()
  }
}

// 打开外部连接带导航栏
export function openUrl (url, external) {
  if (getPlatform().isInApp) {
    window.ULplugin.UApp.openUrl(url, external)
  } else {
    window.open(url)
  }
}

// 更新活动列表通知
export function updateActiveList () {
  window.broadcaster.fireNativeEvent(UGlobalService.getRefreshNotice(), {}, function () {})
}

// 更新单元活动列表
export function unitActivityRefresh (data) {
  if (getPlatform().isInApp) {
    window.broadcaster.fireNativeEvent('unitActivityRefresh', data || {}, function () {})
  }
}

class MobileUploder {
  constructor () {
    this.manger = {}
    let self = this
    this.uploadFile = function (filePath, progress, success, failure) {
      if (this.manger[filePath]) return
      let model = {}
      model.progress = progress
      model.success = success
      model.failure = failure
      this.manger[filePath] = model
      window.ULplugin.UUploader.onUploadProgress = function (filePath, progress) {
        let model = self.manger[filePath]
        if (model) {
          model.progress && model.progress(progress)
        }
      }
      window.ULplugin.UUploader.onUploadCancel = function (filePath) {
        let model = self.manger[filePath]
        if (model) {
          model.cancelSuccess && model.cancelSuccess()
        }
      }
      window.ULplugin.UUploader.onUploadSuccess = function (filePath, remotePath) {
        let model = self.manger[filePath]
        if (model) {
          remotePath = remotePath.replace(commonParams.QINIU_RESOURCE_URL, '')
          remotePath = remotePath.replace('http://leicloud.qiniudn.com/', '')
          remotePath = remotePath.replace('http://tskcloud.qiniudn.cn/', '')
          let richFileArr = ['doc', 'pdf', 'ppt', 'xls']
          let originType = formatLimit(filePath)
          if (richFileArr.indexOf(originType) > -1) {
            // 文档--- 转换
            // Convert.getConvertFile(remotePath)
          } else if (originType === 'video') {
            // 视频 --转换
            // Convert.getConvertVideo(remotePath)
          }
          model.success && model.success(filePath, remotePath)

          delete self.manger[filePath]
        }
      }
      window.ULplugin.UUploader.onUploadFail = function (filePath) {
        let model = self.manger[filePath]
        if (model) {
          model.failure && model.failure()
        }
      }
      window.ULplugin.UUploader.upload(filePath)
    }
    this.cancelUpload = function (filePath, success) {
      if (!this.manger[filePath]) return
      let model = this.manger[filePath]
      model.cancelSuccess = success
    }
  }
}

export function createUploade () {
  return new MobileUploder()
}

class MobileDownloader {
  constructor () {
    this.downloadObj = {}
    // 检查远程文件的本地是否下载成功
    this.checkFileLocalPath = function (path, success, failure) {
      window.ULplugin.UFile.isExist(path, success, failure)
    }
    this.openFileInOtherApp = function (path) {
      window.ULplugin.UFile.openFileInOtherApp(path)
    }
    this.openVideo = function (path) {
      window.ULplugin.UMedia.playVideo(path)
    }
    // 检查网络状态
    this.checkNetworkStatus = function (success) {
      // 1、是wifi 2、是移动网 3、无网络
      window.ULplugin.UApp.networkState((status) => {
        success(status)
      })
    }
    // 开始下载
    this.download = function (path, progress, complete, failure) {
      this.addEventListener(path, progress, complete, failure)
      // path = this.formateDownLoadPath(path, progress, complete, failure)
      window.ULplugin.UFile.download(path)
    }
    this.cancel = function (path) {
      window.ULplugin.UFile.cancelDownload(path)
    }
    // 格式化下载的路径
    this.formateDownLoadPath = function (path, progress, complete, failure) {
      let suffixName = path.split('/').pop()
      let filename = suffixName.split('.')[0]
      // let Obj = this.downloadObj[path]
      // if (!Obj) {
      //   this.downloadObj[path] = {
      //     path: path,
      //     name: suffixName,
      //     progressFns: [progress],
      //     completeFns: [complete],
      //     failureFns: [failure]
      //   }
      // } else {
      //   progress && Obj.progressFns.push(progress)
      //   complete && Obj.completeFns.push(complete)
      //   failure && Obj.failureFns.push(failure)
      // }
      return `${path}?name=${filename}`
    }
    // 添加事件监听，关闭页面，后台正在下载，注册监听方法，可以正确更新文件产状态
    this.addEventListener = function (path, progress, complete, failure) {
      let self = this
      let Obj = self.downloadObj[path]
      if (Obj) {
        Obj.progressFns.push(progress)
        Obj.completeFns.push(complete)
        Obj.failureFns.push(failure)
      } else {
        let suffixName = path.split('/').pop()
        this.downloadObj[path] = {
          path: path,
          name: suffixName,
          progressFns: [progress],
          completeFns: [complete],
          failureFns: [failure]
        }
      }
      window.ULplugin.UFile.onDownloadProgress = function (url, progress) {
        if (progress) {
          console.log(progress)
        }
        console.log('我是进度更新了', url, progress)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.progressFns && Obj.progressFns.length !== 0) {
          Obj.progressFns.forEach((item) => {
            if (progress) {
              item && item(progress)
            }
          })
        }
      }
      window.ULplugin.UFile.onDownloadError = function (url, errmsg) {
        console.log('我异常了', url, errmsg)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.failureFns && Obj.failureFns.length !== 0) {
          Obj.failureFns.forEach((item) => {
            item && item(errmsg)
          })
        }
      }
      window.ULplugin.UFile.onDownloadSuccess = function (url, filePath) {
        console.log('我下载成功了', url, filePath)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.completeFns && Obj.completeFns.length !== 0) {
          Obj.completeFns.forEach((item) => {
            item && item(filePath)
          })
        }
      }
    }
  }
}

export function creatDownloader () {
  return new MobileDownloader()
}

export function playAudio (audioUrl, complete, durationChange) {
  window.ULplugin.UMedia.playAudio(audioUrl, complete, durationChange)
}

export function stopAudio () {
  window.ULplugin.UMedia.stopAudio()
}



// WEBPACK FOOTER //
// ./src/common/js/mobilePlugin.js